import { Component } from '@angular/core';
import { DataLayerBaseComponent } from './data-layer-base.component';
import { DataLayerGeojsonPointComponent } from './data-layer-geojson-point.component';
import { MapService } from './map.service';
import { DataLayerService } from './data-layer.service';
import { ConfigService } from './config.service';
import { UserMessageService } from './user-message.service';

declare var L;

/*
 * data-layer-geojson-wind defines a class to display wind data.  The data format is geojson.
 *	WindDir determines the angle the arrow is rotated.  The WindSpeed determines the width of the arrow.
 *
 * Example of the data file:
 * --------------------------------
 * {
 *	"type": "FeatureCollection",
 *	"name": "windDir_sample_point",
 *	"crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
 *	"features": [
 *	{ "type": "Feature", "properties": { "POINTID": 10004, "WindDir": 320, "WindSpeed": 50 }, "geometry": { "type": "MultiPoint", "coordinates": [ [ -105.40025, 39.81463 ] ] } },
 *	  ...
 *	]
 * }
 * --------------------------------
 *
 * Within the configuration file, wind stations can be included:
 * "overlayLayers": [
 * 		{"id": "windLayer", "label": "Wind", "url": "map/overlay-layers/windDir.geojson",
 *			"class": "data-layer-wind", "refresh": true }
 * ...
 * ]
 */

@Component({
	selector: 'data-layer-wind',
	standalone: false,
	template: `
		<div class="checkboxDiv">
			<label class="overlay-layer"><input type="checkbox" (click)="menuControlSelected($event)">{{htmlElementLabel}}</label>
			<app-single-legend [active]=active [legendUrl]=legendUrl></app-single-legend>
		</div>
		`,
	styleUrls: ['app.component.css']
})
export class DataLayerGeojsonWindComponent extends DataLayerGeojsonPointComponent {


	constructor (
		mapService: MapService, dataLayerService: DataLayerService, configService: ConfigService, userMessageService: UserMessageService ) {

		super (mapService, dataLayerService, configService, userMessageService );
		this.htmlElementLabel = 'Wind';
	}

	onEachPointFeature(feature, layer) {
		// console.log(feature);
		/*
		var stationName = "name";
		var popupContent, tooltipContent;
		//var options = {"maxWidth": 600};
		var options;

		// Assign HTML content to use in a popup when the user clicks on a marker

			var linkStr = "link";
			var imageStr = "image";
			var height = "image_height";
			var width = "image_width";
			popupContent = "<p style='font-size:20px'>" + feature.properties[stationName] +
				"<img src='" + feature.properties[imageStr] + "' style='height:" + feature.properties[height] +
				"px; width:" + feature.properties[width] + "'>" +
				"<br><a href='" + feature.properties[linkStr] + "' target='_blank'>" + feature.properties[linkStr] + "</a>";
			options = { "minWidth": feature.properties[width] };
			tooltipContent = feature.properties[stationName] + " (click for more info)";

		if (feature.properties && feature.properties.popupContent) {
			// This will append content from a "popupContent" property if it is in the GeoJSON file
			popupContent += feature.properties.popupContent;
		}

		layer.bindPopup(popupContent, options);
		layer.bindTooltip(tooltipContent);
		*/
	}

	placeMarkers(feature, latlng) {
		let marker;
		// this is undefined at this point // console.log(this); // self.mapService.map.getZoom());

		const size = 0 + ( feature.properties.WindSpeed || 0);

		marker = L.icon ({
			iconUrl: 'assets/images/arrow-up.png',
			iconSize: [size, size]
		});

		return L.marker(latlng, { icon: marker, rotationAngle: feature.properties.WindDir });
		// Maybe look at  https://stackoverflow.com/questions/45479872/leaflet-map-rotated-marker-for-ionic2-typescript/45506208#45506208
	}




}
